export default {
  homePageCustomerClickable: true,
  homePageCustomerCopiable: true,
  newPromotion: true,
  zambiaLeader: true,
  CustomerContactCopyable: true,
  CustomerContactClickable: true,
};
